bind {{ harness.env.dut.type }}{{#if (gt envInstanceHierarchicalPropertiesObject.envInstanceHier.length 1)}}: {{#each envInstanceHierarchicalPropertiesObject.envInstanceHier delimeter="."}}{{ hdlPathWithDimensionVariables }}{{/each}}{{/if}} {{ harness.type }} #(
{{#each harness.allParameters delimeter=","}}
  .{{ name }} ({{ name }})
{{/each}}
) {{ harness.type }} (.*);
